<div
	class="flex items-center rounded text-xs h-5 justify-center max-w-fit py-0.5 px-1  {{
		variant()
	}}"
	data-cy="ui-tag"
>
	@if (icon()) {
		<ui-icon
			[size]="sizes.XS"
			class="cursor-pointer"
			[icon]="icon()"
			(click)="onIconClick()"
		></ui-icon>
	}
	<div class="px-0.5 line-clamp-1 text-ellipsis">
		{{ text() }}
	</div>
</div>
